<template>
  <div class="card-923">
    <div class="row">
      <div class="col-12 justify-content-center card-923-body text-center rounded">
        <div class="wrapper-card-img">
          <div class="wrapper-card-img2"></div>
        </div>
        <img class="card-923-body-img " :src="image" :alt="alt">

        <slot name="p-1">
          <h3 class="my-2">
            meysam
          </h3>
        </slot>

        <slot name="p-2">
          <p class="my-2">
            gheitasi
          </p>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card923",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  },
}

</script>

<style scoped>
.card-923 {
  z-index: 1;
  position: relative;
  border: 1px double #a4a4a4;
  border-radius: 15px;
  background: #fff;
}

.wrapper-card-img {
  overflow: hidden;
  background-color: transparent;
}

.wrapper-card-img2 {
  z-index: 20;
  position: relative;
  margin: auto;
  height: 100px;
  width: 100px;
  object-fit: cover;
  border-radius: 50%;
  padding: 8px;
  background: transparent;
  margin-top: -50px;
  border: 1px double #a4a4a4;
}

.card-923-body-img {
  position: relative;
  z-index: 2;
  height: 100px;
  width: 100px;
  object-fit: cover;
  border-radius: 50%;
  background: #FFFFFF;
  padding: 8px;
  margin-top: -118px;
}
</style>